import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Divider,
  Typography,
} from "@mui/material";

import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import ExpandableText from "../../components/ExpandableText/ExpandableText";
import imgAbby from "../../assets/Headshots/IMG_1502.jpg";
import imgBetty from "../../assets/Headshots/IMG_1750.jpg";
import imgJakayla from "../../assets/Headshots/IMG_1779.jpg";
import imgTyron from "../../assets/Headshots/IMG_1822.jpg";
import imgAngeles from "../../assets/Headshots/IMG_1894.jpg";
import imgHarmony from "../../assets/Headshots/IMG_1934.jpg";
import imgFaith from "../../assets/Headshots/IMG_2080.jpg";
import imgAiden from "../../assets/Headshots/IMG_2122.jpg";
import imgDeon from "../../assets/Headshots/IMG_2140.jpg";
import imgRose from "../../assets/Headshots/IMG_2514.jpg";

const participants = [
  {
    id: 1,
    name: "Aby Glazier",
    photo: imgAbby,
    institution: "Holmes Community College",
    program: "Library and Information Science",
    bio: `Abigail “Aby” Glazier is a Kosciusko resident and graduate of Holmes Community College with a research interest in building community narratives via digitization. She will be attending the University of Southern Mississippi in the fall of 2026 to study Library and Information Science. Aby applied for the Summer Digital Humanities Hub Residency to expand her knowledge of digital tools that are becoming increasingly necessary in the LIS field.  `,
    residencyExperience: `Aby’s DHH project focuses on the Pascagoula, MS alien abduction of Charles (Charlie) Hickson and Calvin Parker in 1973. Utilizing StoryMaps, she has analyzed how preexisting pop culture elevated the Pascagoula abduction, causing it to explode outside of Mississippi’s borders. Through her time at the Hub, she learned how to digitize comic book panels, create a map of UFO encounters surrounding Pascagoula through ArcGIS, and design a visually interesting narrative for her website “It’s a Bird, It’s a Plane, It’s . . . a UFO?!” She aims to utilize these digital research skills throughout the rest of her education and take them into the LIS work field.`,
    projectUrl: "https://arcg.is/1vq0bm6",
  },
  {
    id: 2,
    name: "Aiden Risher",
    photo: imgAiden,
    institution: "The University of Southern Mississippi",
    program: "Anthropology and Library & Information Science",
    bio: `Aiden Risher is a University of Southern Mississippi student from Madden, MS. He is double majoring in Anthropology and Library & Information Sciences with a minor in Psychology. He is a member of the Culture, Values, and Well-being experimental psychology lab and is currently working on his honors thesis on student AI use. He is interested in applying his interdisciplinary knowledge base to research social groups and relationships, and his primary research interest is in the way media and technology affect intergroup relations and individual relationships. `,
    residencyExperience: `This residency provided him with an excellent opportunity to expand his research expertise in digital humanitarian research methods, with particular emphasis on data analysis, text analysis, and ArcGIS mapping systems. It also provided an excellent opportunity to collaborate with fellow undergraduate scholars and connect with research professionals across the humanities. His research project for this program analyzes the impact that the Mississippi paranormal tourism industry has on the ways that ghost stories preserve history, particularly the erasure of slavery narratives.`,
    projectUrl: "https://arcg.is/mW5Lr",
  },
  {
    id: 3,
    name: "Amber Rose Caston",
    photo: imgRose,
    institution: "Millsaps College",
    program: "English Literature, Creative Writing, and History",
    bio: `Amber Rose Caston is currently a rising fourth year student at Millsaps College. She is currently working toward a Bachelor of Arts in English Literature and Creative Writing and a second Bachelor of Arts in History. She is also a Digital Welty Lab fellow at Millsaps College and has been creating digital projects since her freshman year of college and is the lead research assistant for the A Piece of News .`,
    residencyExperience: (
      <>
        Her intrigue for the USM Digital Humanities Hub Residency arose as she
        was searching for ways to evolve and improve her scholarly research and
        acquire skills for the digital world that would allow her have a
        scholarly voice and a chance to take new skills with her as she
        continues her undergraduate studies. The leadership team for this
        program allowed her to approach topics that were familiar, while
        challenging her to explore innovative ways of illustration, display, and
        creativity. She is proud to present Where Is The Voice Coming From?, a
        digital poem guide through Eudora Welty’s literary world, and intends to
        use her position as a Digital Welty Lab employee to continue to evolve
        this project. She is grateful for the opportunity to learn and grow from
        this workshop and will try her best to use her knowledge gained to teach
        others. she developed an interactive StoryMap exploring Mississippi
        history. You can explore the project{" "}
        <a
          href="https://storymaps.arcgis.com/stories/afbefeb3c97d4180ac98a323a6a26257"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#9a6700",
            fontWeight: 600,
            textDecoration: "underline",
          }}
        >
          here.
        </a>
      </>
    ),
    projectUrl: "https://www.whereisthevoicecomingfrom.usmcdh.org/",
  },
  {
    id: 4,
    name: "Angeles Peters",
    photo: imgAngeles,
    institution: "Belhaven University",
    program: "History",
    bio: `Angeles Peters is an undergraduate student at Belhaven University pursuing a degree in History, with additional academic interests in English and a long-term goal of becoming an educator. She is an active member of the University’s Honors Program, Black Student Association, and Gaming Association. Alongside her studies, Angeles serves as the History Department’s sole work-study student, supporting a wide range of departmental initiatives, from records management and data entry to coordinating aspects of Belhaven University’s most recent Honors Conference.`,
    residencyExperience: `Angeles has developed a strong interest in the field of Digital Humanities and is honored to have been selected for this program. Through the experience, she has had the opportunity to collaborate with talented peers and mentors while gaining valuable interdisciplinary knowledge and skills. Her project reflects both her academic interest in Mississippi history and her commitment to advocacy by examining educational inequalities within the state and highlighting the enduring impact of historical systems of racial discrimination on educational opportunity.`,
    projectUrl:
      "https://storymaps.arcgis.com/stories/6bc6d5c71eb74737bbbcb3d063def97b",
  },
  {
    id: 5,
    name: "Betty Duggan",
    photo: imgBetty,
    institution: "The University of Southern Mississippi",
    program: "Disability Studies",
    bio: `Betty Duggan is a University of Southern Mississippi student from Oak Grove, Mississippi, majoring in Disability Studies with a minor in French and Certification in Diversity, Equity, and Inclusion. She is currently working on her thesis for the Southern Miss Honors College and is the Treasurer for L’Association Française. Her research interests consist of Gendered Mental Health Medicine and Treatments, as well as social diagnoses in both the Romantic and Victorian eras.`,
    residencyExperience: `She attended the Digital Humanities Summer Residency to strengthen her knowledge of data visualization and disability accessibility in the humanities. Her focus in the residency is finding the hysterical woman through the 1880s-1920s in Mississippi. In studying Medical Journals, Asylum Records, and Advertisements circling in Mississippi through those years, she works to highlight and visualize the demographic of people diagnosed and treated for hysteria. Through this research, she has learned to present her data digitally, create academic websites, and form games on the internet. She is so excited to have this opportunity with the Mississippi Digital Humanities Hub. `,
    projectUrl: "https://arcg.is/1X1G1e1",
  },
  {
    id: 6,
    name: "Deon Wright II",
    photo: imgDeon,
    institution: "Rust College",
    program: "Media Studies, African American History, and Music History",
    bio: `Deon Wright II is a rising junior at Rust College in Holly Springs, Mississippi. Originally from Chicago, Illinois, he has a strong interest in media studies, African American history and culture, and the history of music. He chose to participate in the Digital Humanities Summer Residency because he wanted to strengthen skills in digital humanities and communications, including text analysis, digital mapping, and the digitization of historical documents and other resources. These skills will not only help him grow academically and professionally but also allow him to use media and digital storytelling to serve others and preserve important histories.`,
    residencyExperience: `His project explores the claim made by Robert Palmer in his Rolling Stone article that Hattiesburg, Mississippi, is the birthplace of rock and roll. Through this research, he examines the story of the Graves Brothers, whose music Palmer referenced, and explore how their work connects to the blues and the emergence of early rock and roll. By bringing these stories together, his goal is to highlight Hattiesburg’s often overlooked role in the development of one of America’s most influential musical genres. `,
    projectUrl:
      "https://storymaps.arcgis.com/stories/567766f3872944e7bb7888a0a11166b5",
  },
  {
    id: 7,
    name: "Faith Holloway",
    photo: imgFaith,
    institution: "The University of Southern Mississippi",
    program: "Communication Studies and Graphic Design",
    bio: `Faith Holloway was born and raised on the Gulf Coast of Mississippi, where she soon began attending the University of Southern Mississippi, majoring in Communication Studies and minoring in Graphic Design. During her time there, she has earned multiple scholarships, joined the Honors College, traveled abroad to Italy to further her education, and is now participating in the Mississippi Digital Humanities Program, conducting research on the evolution of courtesy titles in Mississippi sparked by a facinating court case. `,
    residencyExperience: `Choosing to attend this summer residency was an easy decision for her; she has always been drawn to both research and technology, and digital humanities blends the two perfectly. For Faith, being in this program has opened doors to many different walks of life and introduced her to people she might never have met otherwise. Here, she has built meaningful connections, uncovered untold histories through archival work, explored research studies across digital platforms, and learned new software—embracing the mistakes that come with learning and celebrating the growth that follows. To her, this program has been an absolute blast. `,
    projectUrl:
      "https://storymaps.arcgis.com/stories/4bf7432d831646889a21f7c0a31dc6e2",
  },
  {
    id: 8,
    name: "Harmony Hawthorn",
    photo: imgHarmony,
    institution: "Hinds Community College",
    program: "History",
    bio: `Harmony Hawthorn is currently going into her second year at Hinds Community College majoring in history and is from Brandon, Mississippi. She is generally interested in researching marginalized voices and cultures.`,
    residencyExperience: `Her motivation for attending this summer residency was to learn more about digital humanities and the skills needed to work with it. It was actually the humanities Professor at her school who encouraged her to apply for this program after seeing how well she did at her digitization internship at the Utica Institute Museum.  Her DH project is about Choctaw folklore and how it helps the community maintain their cultural identity in modern day Mississippi. She plans on continuing the research after this program. `,
    projectUrl: "https://usmdigitalhumanities.omeka.net/exhibits/show/folkore",
  },
  {
    id: 9,
    name: "Jakayla McCarroll",
    photo: imgJakayla,
    institution: "Mississippi State University",
    program: "Political Science, Pre-Law",
    bio: `Jakayla McCarroll is a Political Science (Pre-Law) student from Grenada, Mississippi that is attending Mississippi State University with research interests in civil rights history, digital humanities, and public history. `,
    residencyExperience: `She chose to attend the Summer Digital Humanities Residency to expand her research skills and explore innovating ways to present historical narratives through digital scholarship. Her digital humanities project examines the history of antilynching efforts in Mississippi, highlighting the individuals, organizations, and communities, that fought against racial violence and advocated for justice. Through an interactive digital map and timeline, the project traces significant events, key locations, and influential figure, including Father Divine and the Peace Mission Movement, to illustrate their contributions within the broader struggle against lynching. Jakayla hopes to preserve overlooked histories, increase public engagement with the past, and support future scholarship on civil rights and social justice. `,
    projectUrl: "https://arcg.is/rSbLq1",
  },
  {
    id: 10,
    name: "Tyron Rhodes",
    photo: imgTyron,
    institution: "The University of Southern Mississippi",
    program: "History, Education, and Rhetoric",
    bio: `Tyron Rhodes is a sophomore at the University of Southern Mississippi from Mobile, Alabama. His research interests center on nineteenth- and twentieth-century African American history, educational policy, and rhetoric. This summer residency provided an opportunity to engage intensively with the research process while learning digital tools that he plans to incorporate into his future secondary classroom. His interest in the digital humanities grew from his aspirations as an educator, and the residency allowed him to explore how digital methods can enrich both historical scholarship and classroom instruction.`,
    residencyExperience: `Rhodes’s digital humanities project immerses audiences in the classroom materials of the 1964 Mississippi Freedom Summer Schools. The project argues that the curriculum developed for the Freedom Schools was more than a collection of lesson plans; it was a radical educational blueprint that reimagined the purpose of schooling itself. By reconstructing the curriculum through archival documents, student work, historical maps, photographs, and contemporary digital tools, Rhode’s project demonstrates how Freedom School students experienced an education grounded in historical inquiry, civic participation, and social transformation. `,
    projectUrl:
      "https://usmdigitalhumanities.omeka.net/exhibits/show/curriculum",
  },
];

const getInitials = (name = "") =>
  name
    .trim()
    .split(/\s+/)
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

const getProjectDomain = (url = "") => {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return "";
  }
};

const isValidProjectUrl = (url = "") => {
  try {
    const parsed = new URL(url);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
};

const Participants2026 = () => {
  useEffect(() => {
    document.title = "Summer Residency 2026 Participants - MS Digital Hub";
  }, []);
  const [expandedSections, setExpandedSections] = React.useState({});
  const toggleSection = (participantId, section) => {
    const key = `${participantId}-${section}`;

    setExpandedSections((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#ffffff",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 1600,
          mx: "auto",
          px: {
            xs: 1.5,
            sm: 2,
            md: 3,
            lg: 4,
          },
          py: {
            xs: 4,
            md: 5,
          },
        }}
      >
        {/* Page heading */}
        <Box
          sx={{
            mb: { xs: 3, md: 4 },
            textAlign: "center",
          }}
        >
          <Typography
            sx={{
              color: "#b7791f",
              fontWeight: 700,
              letterSpacing: "0.06em",
              textTransform: "uppercase",
              fontSize: { xs: "0.78rem", sm: "0.85rem" },
              mb: 1,
            }}
          >
            Summer Residency 2026
          </Typography>

          <Typography
            variant="h4"
            component="h1"
            sx={{
              fontWeight: 500,
              color: "#111827",
              display: "inline-block",
              borderBottom: "2px solid #FFD700",
              pb: 1,
              mb: 2,
              fontSize: {
                xs: "1.65rem",
                sm: "1.9rem",
                md: "2.1rem",
              },
            }}
          >
            Meet Our Workshop Participants
          </Typography>

          <Typography
            sx={{
              color: "#555555",
              fontSize: { xs: "0.94rem", md: "1rem" },
              lineHeight: 1.8,
              maxWidth: 900,
              mx: "auto",
            }}
          >
            Meet the scholars participating in the Summer Residency 2026. Learn
            about their backgrounds, the ways the residency supported their
            growth, and the digital humanities projects they developed during
            the program.
          </Typography>
        </Box>

        <Divider sx={{ mb: 4, borderColor: "#dddddd" }} />

        {/* Participant cards */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              md: "repeat(2, minmax(0, 1fr))",
            },
            gap: {
              xs: 2,
              md: 2.5,
            },
            alignItems: "start",
          }}
        >
          {participants.map((participant) => {
            const hasProjectUrl = isValidProjectUrl(participant.projectUrl);

            const projectDomain = hasProjectUrl
              ? getProjectDomain(participant.projectUrl)
              : "";

            return (
              <Card
                key={participant.id}
                elevation={0}
                sx={{
                  width: "100%",
                  borderRadius: 2.5,
                  border: "1px solid #e3e3e3",
                  backgroundColor: "#ffffff",
                  overflow: "hidden",
                  transition:
                    "transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease",

                  "&:hover": {
                    transform: {
                      xs: "none",
                      md: "translateY(-3px)",
                    },
                    borderColor: "#d4b15d",
                    boxShadow: "0 12px 28px rgba(0,0,0,0.08)",
                  },
                }}
              >
                <CardContent
                  sx={{
                    p: { xs: 2, sm: 2.5, md: 2.75 },

                    "&:last-child": {
                      pb: { xs: 2, sm: 2.5, md: 2.75 },
                    },
                  }}
                >
                  {/* Participant heading */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: {
                        xs: "column",
                        sm: "row",
                      },
                      alignItems: {
                        xs: "center",
                        sm: "flex-start",
                      },
                      textAlign: {
                        xs: "center",
                        sm: "left",
                      },
                      gap: { xs: 1.5, sm: 2 },
                    }}
                  >
                    <Avatar
                      src={participant.photo || undefined}
                      alt={participant.name}
                      sx={{
                        width: { xs: 90, sm: 105 },
                        height: { xs: 90, sm: 105 },
                        border: "3px solid #e2e2e2",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                        backgroundColor: "#fff7df",
                        color: "#8a6211",
                        fontWeight: 700,
                        fontSize: "1.25rem",
                        flexShrink: 0,
                      }}
                    >
                      {getInitials(participant.name)}
                    </Avatar>

                    <Box sx={{ minWidth: 0, flex: 1 }}>
                      <Typography
                        component="h2"
                        sx={{
                          fontFamily: "Georgia, serif",
                          fontWeight: 700,
                          color: "#222222",
                          fontSize: {
                            xs: "1.22rem",
                            md: "1.4rem",
                          },
                          lineHeight: 1.25,
                        }}
                      >
                        {participant.name}
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "flex-start",
                          justifyContent: {
                            xs: "center",
                            sm: "flex-start",
                          },
                          gap: 0.6,
                          mt: 0.9,
                        }}
                      >
                        <SchoolOutlinedIcon
                          sx={{
                            fontSize: 17,
                            color: "#b7791f",
                            mt: "2px",
                            flexShrink: 0,
                          }}
                        />

                        <Typography
                          sx={{
                            color: "#b7791f",
                            fontWeight: 600,
                            fontSize: "0.9rem",
                            lineHeight: 1.45,
                          }}
                        >
                          {participant.institution}
                        </Typography>
                      </Box>

                      {participant.program && (
                        <Typography
                          sx={{
                            mt: 0.5,
                            color: "#555555",
                            fontStyle: "italic",
                            fontSize: "0.9rem",
                          }}
                        >
                          {participant.program}
                        </Typography>
                      )}
                    </Box>
                  </Box>

                  <Divider
                    sx={{
                      my: 2.25,
                      borderColor: "#e4e4e4",
                    }}
                  />

                  {/* Biography */}

                  <Box>
                    {" "}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.7,
                        mb: 0.9,
                      }}
                    >
                      {" "}
                      <PersonOutlineIcon
                        sx={{
                          color: "#b7791f",
                          fontSize: 18,
                        }}
                      />{" "}
                      <Typography
                        sx={{
                          color: "#9a6700",
                          fontWeight: 700,
                          fontSize: "0.74rem",
                          letterSpacing: "0.07em",
                          textTransform: "uppercase",
                        }}
                      >
                        Bio{" "}
                      </Typography>{" "}
                    </Box>
                    <ExpandableText text={participant.bio} lines={6} />
                  </Box>

                  <Divider
                    sx={{
                      my: 2.25,
                      borderColor: "#e4e4e4",
                    }}
                  />

                  {/* Residency experience */}
                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.7,
                        mb: 0.9,
                      }}
                    >
                      <AccountTreeOutlinedIcon
                        sx={{
                          color: "#b7791f",
                          fontSize: 18,
                        }}
                      />

                      <Typography
                        sx={{
                          color: "#9a6700",
                          fontWeight: 700,
                          fontSize: "0.74rem",
                          letterSpacing: "0.07em",
                          textTransform: "uppercase",
                        }}
                      >
                        Residency Experience and Project
                      </Typography>
                    </Box>

                    <ExpandableText
                      text={participant.residencyExperience}
                      lines={6}
                    />
                  </Box>

                  <Divider
                    sx={{
                      my: 2.25,
                      borderColor: "#e4e4e4",
                    }}
                  />

                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.7,
                        mb: 1,
                      }}
                    >
                      <LanguageOutlinedIcon
                        sx={{
                          color: "#b7791f",
                          fontSize: 18,
                        }}
                      />

                      <Typography
                        sx={{
                          color: "#9a6700",
                          fontWeight: 700,
                          fontSize: "0.74rem",
                          letterSpacing: "0.07em",
                          textTransform: "uppercase",
                        }}
                      >
                        Digital Humanities Project
                      </Typography>
                    </Box>

                    {hasProjectUrl ? (
                      <Box
                        sx={{
                          border: "1px solid #dfd4bb",
                          borderRadius: 2,
                          overflow: "hidden",
                          backgroundColor: "#ffffff",
                          transition:
                            "transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease",

                          "&:hover": {
                            borderColor: "#c99822",
                            boxShadow: "0 10px 24px rgba(71,52,12,0.12)",
                          },
                        }}
                      >
                        {/* Browser-style header */}
                        <Box
                          component="a"
                          href={participant.projectUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={{
                            px: 1.4,
                            py: 1,
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            backgroundColor: "#f5f5f5",
                            borderBottom: "1px solid #e2e2e2",
                            textDecoration: "none",
                            color: "inherit",
                            cursor: "pointer",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              gap: 0.55,
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              sx={{
                                width: 8,
                                height: 8,
                                borderRadius: "50%",
                                backgroundColor: "#d5a6a6",
                              }}
                            />

                            <Box
                              sx={{
                                width: 8,
                                height: 8,
                                borderRadius: "50%",
                                backgroundColor: "#d8c17a",
                              }}
                            />

                            <Box
                              sx={{
                                width: 8,
                                height: 8,
                                borderRadius: "50%",
                                backgroundColor: "#9fc4a8",
                              }}
                            />
                          </Box>

                          <Box
                            sx={{
                              flex: 1,
                              minWidth: 0,
                              borderRadius: 1,
                              backgroundColor: "#ffffff",
                              border: "1px solid #dddddd",
                              px: 1.1,
                              py: 0.45,
                            }}
                          >
                            <Typography
                              noWrap
                              sx={{
                                color: "#666666",
                                fontSize: "0.74rem",
                              }}
                            >
                              {projectDomain}
                            </Typography>
                          </Box>

                          <ArrowOutwardIcon
                            sx={{
                              color: "#9a6700",
                              fontSize: 18,
                              flexShrink: 0,
                            }}
                          />
                        </Box>

                        {/* Live website preview */}
                        <Box
                          sx={{
                            position: "relative",
                            width: "100%",
                            height: {
                              xs: 260,
                              sm: 320,
                              md: 360,
                            },
                            backgroundColor: "#f7f7f7",
                            overflow: "hidden",
                          }}
                        >
                          <Box
                            component="iframe"
                            src={participant.projectUrl}
                            title={`${participant.name} digital humanities project`}
                            loading="lazy"
                            sx={{
                              width: "100%",
                              height: "100%",
                              border: 0,
                              display: "block",
                              backgroundColor: "#ffffff",
                            }}
                          />
                        </Box>

                        {/* Clickable footer */}
                        <Box
                          component="a"
                          href={participant.projectUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={{
                            px: {
                              xs: 1.5,
                              sm: 1.75,
                            },
                            py: 1.2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 0.75,
                            backgroundColor: "#fffaf1",
                            borderTop: "1px solid #ecdfc1",
                            textDecoration: "none",
                            color: "#9a6700",
                            fontWeight: 700,
                            transition: "background-color 0.2s ease",

                            "&:hover": {
                              backgroundColor: "#fff2d8",
                            },
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: "0.88rem",
                            }}
                          >
                            Explore Project
                          </Typography>

                          <ArrowOutwardIcon
                            sx={{
                              fontSize: 18,
                            }}
                          />
                        </Box>
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          border: "1px solid #e2e2e2",
                          borderRadius: 2,
                          px: 2,
                          py: 2.25,
                          display: "flex",
                          alignItems: "center",
                          gap: 1.25,
                          backgroundColor: "#fafafa",
                        }}
                      >
                        <LanguageOutlinedIcon
                          sx={{
                            color: "#999999",
                            fontSize: 24,
                            flexShrink: 0,
                          }}
                        />

                        <Box>
                          <Typography
                            sx={{
                              color: "#555555",
                              fontWeight: 700,
                              fontSize: "0.9rem",
                            }}
                          >
                            Project website coming soon
                          </Typography>

                          <Typography
                            sx={{
                              mt: 0.3,
                              color: "#777777",
                              fontSize: "0.82rem",
                              lineHeight: 1.5,
                            }}
                          >
                            A link to this participant’s project will be added
                            when it becomes available.
                          </Typography>
                        </Box>
                      </Box>
                    )}
                  </Box>
                </CardContent>
              </Card>
            );
          })}
        </Box>

        {/* Closing message */}
      </Box>
    </Box>
  );
};

export default Participants2026;
